<template>
  <div>
    <!-- Filters -->
    <items-list-filters
      :item-filter.sync="itemStatusFilter"
      :items-status-options="itemsStatusOptions"
    />

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Affichage</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>Produits</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Rechercher..."
              />
              <b-button
                variant="primary"
                @click="$router.push({ name: 'apps-item-add' })"
              >
                <span class="text-nowrap">Ajouter Produit</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refItemsListTable"
        class="position-relative"
        :items="fetchItemsList"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Pas de produit trouvé"
        :sort-desc.sync="isSortDirDesc"
      >
              <!-- A virtual column -->
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

        <!-- Column: Brand -->
        <template #cell(brand)="data">
            <span>{{ data.item.brand.name }}</span>
        </template>

        <!-- Column: Categories -->
        <template #cell(categories)="data">
          <b-badge v-for="(category, i) in data.item.categories" :key="i" variant="warning" class="text-capitalize mr-1">
            <span>{{ category.name }}</span>
          </b-badge>
        </template>

        <!-- Column: Status -->
        <template #cell(is_depreciable)="data">
          <b-badge :variant="data.item.is_depreciable ? 'primary' : 'danger'" class="text-capitalize">
            {{ data.item.is_depreciable ? "Oui" : "Non" }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <feather-icon
              :id="`item-row-${data.item.uid}-edit-icon`"
              icon="EditIcon"
              class="cursor-pointer text-warning"
              size="16"
              @click="
                $router.push({
                  name: 'apps-item-edit',
                  params: { id: data.item.uid }
                })
              "
            />
            <b-tooltip
              title="Modifier"
              class="cursor-pointer"
              :target="`item-row-${data.item.uid}-edit-icon`"
              placement="left"
            />

            <feather-icon
              :id="`item-row-${data.item.uid}-delete-icon`"
              icon="TrashIcon"
              size="16"
              class="mx-1 text-danger"
              @click="deleteItem(data.item.uid)"
            />
            <b-tooltip
              title="Supprimer"
              :target="`item-row-${data.item.uid}-delete-icon`"
              placement="right"
            />
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur
              {{ dataMeta.of }} produits</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import {
  BTooltip,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ItemsListFilters from "./ItemsListFilters.vue";
import useItemsList from "./useItemsList";

export default {
  name: "ItemsList",
  components: {
    ItemsListFilters,

    BTooltip,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,

    vSelect,
  },
  setup() {
    const {
      fetchItemsList,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refItemsListTable,
      refetchData,
      toggleItem,
      deleteItem,

      // Extra Filters
      itemStatusFilter,
      itemsStatusOptions,
    } = useItemsList();

    return {
      fetchItemsList,
      tableColumns,
      perPage,
      currentPage,
      totalItems,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refItemsListTable,
      refetchData,
      toggleItem,
      deleteItem,

      itemStatusFilter,
      itemsStatusOptions,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
